import {collision} from './collision';

export class Tent {
	constructor(game) {
		this.game = game;
		this.image = document.getElementById('tent');
		this.imageScale = 0.3;
		this.width = this.image.width * this.imageScale;
		this.height = this.image.height * this.imageScale;
		this.x = this.setXposition();
		this.y = this.game.height - this.height - this.game.groundMargin;
		this.collisiion = false;
		this.show = false;
		this.multiplicity = Math.round((this.game.maxBlocks - 8) / this.game.popupMain.starsContent.length);
		this.notVisited = false;
		// this.speed = this.game.speed / 1.5;
		this.speed = this.game.speed;
	}

	setXposition() {
		return this.game.width + this.game.width / 3;
	}

	continue() {
		this.closePopup();
		this.game.play();
	}

	update(player) {
		if (this.game.currentBlocks && this.game.currentBlocks % this.multiplicity === 0 && !this.show) {
			this.show = true;
			this.game.showNewBlocks = false;
			// this.multiplicity *= 2;
		}

		if (collision(player, this) && !this.collisiion && !this.notVisited) {
			this.game.popupMain.openStars();
			this.notVisited = true;
			this.game.showNewBlocks = true;
			this.game.blockStep = 0;
		}

		if (this.show && this.x + this.width >= 0) {
			this.x -= this.speed;
		} else {
			this.show = false;
			this.x = this.setXposition();
			this.collisiion = false;
			this.notVisited = false;
			// this.gameStop = false;
		}
	}

	draw() {
		if (!this.collisiion) {
			this.game.ctx.drawImage(this.image, this.x, this.y, this.width, this.height);
		}
	}

	openPopup() {
		this.popup.style.display = 'block';
	}

	closePopup() {
		this.popup.style.display = 'none';
	}

	resize() {
		this.x = this.setXposition();
		this.y = this.game.height - this.height - this.game.groundMargin;
	}

	reset() {
		this.show = false;
		this.collisiion = false;
		this.notVisited = false;
	}
}
